module.exports = "/images/flag-en.svg?05c52fc6c3f7119b6f34f38c85206ada";